/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class GroupByTerminology {
    getFixupPrototypeFunction() { return GroupByTerminology.fixupPrototype; }

    static newInstance(model: Partial<GroupByTerminology>): GroupByTerminology {
        let obj = Object.assign(new GroupByTerminology(), model);
        GroupByTerminology.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<GroupByTerminology>): GroupByTerminology {
        if (!model) return null;
        return GroupByTerminology.newInstance(<GroupByTerminology> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: GroupByTerminology) {
        if (!obj) return;

        models.GroupByTerminology.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: GroupByTerminology): boolean {
        Object.setPrototypeOf(obj, GroupByTerminology.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Dimension to group results by
     */
    selector: models.BillingGroupBySelector;

    /**
     * Key of the group-by, as given in the request
     */
    key: string;

    /**
     * Display label for this group-by dimension
     */
    terminology: string;

}
